
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class BatchService {
    private baseApiUrl: string;

    constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
        this.baseApiUrl = configurationService.BaseApiUrl;
    }

    public createBatch(noOfDays: number): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + `batch/endofday?noOfDays=${noOfDays}`, {}).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    public queue(): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + 'batch/queue', {}).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    public requeue(batchId: number): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + `batch/requeue/${batchId}`, {}).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    public getStatus(batchId: number): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `batch/status/${batchId}`).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }
      saveeodbatchprocesslist(branchDetails: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'batch/saveeodbatchprocesslist', branchDetails).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }
    getFiltered(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
    };

    return this.httpClient.post(this.baseApiUrl + 'batch/filter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  updateAutomaticBranch(automaticBranch: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'batch', automaticBranch).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  getBranchById(id: number, forMaintenance: boolean = true): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `batch/${id}?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

        listofbranchEod(branchDetails: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'batch/listofbranchEod', branchDetails).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }
}
